import WhatsAppIcon from "@/components/WhatsAppIcon";
import analytics from "@/utils/analytics";
import { whatsAppUrl } from "@/utils/whatsapp";

const VARIANTS = {
  primary:
    "inline-flex items-center justify-center gap-2 bg-brand-aqua hover:bg-brand-aqua-dark text-white font-semibold rounded-full px-8 py-3.5 text-sm transition-colors",
  secondary:
    "inline-flex items-center justify-center gap-2 border border-brand-light-grey hover:border-brand-aqua text-brand-black font-semibold rounded-full px-6 py-3 text-sm transition-colors",
  link:
    "inline-flex items-center gap-1.5 text-brand-aqua hover:text-brand-aqua-dark font-semibold transition-colors",
};

export default function WhatsAppButton({
  placement = "float",
  variant = "primary",
  label = "WhatsApp us",
  iconSize = 18,
  className = "",
  children,
  ...rest
}) {
  return (
    <a
      href={whatsAppUrl(placement)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => analytics.clickWhatsApp(placement)}
      aria-label={`${label} — opens WhatsApp`}
      data-testid={`whatsapp-${placement}`}
      className={`${VARIANTS[variant] || VARIANTS.primary} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-aqua focus-visible:ring-offset-2 ${className}`}
      {...rest}
    >
      <WhatsAppIcon size={iconSize} />
      {children || label}
    </a>
  );
}
